import React, {Component} from 'react';
import {BlockComponentProps} from 'client-react-block-renderer';
import {
    PreviewAndPopupPlayerContainer,
    FixedAspectRatioPlayer,
} from 'vimeo-popup-player';
import {isEditing} from 'pws-client';
import {Editable, ButtonListSelectField} from 'forms-editable';
import t from 'rcm-i18n';
import './PwsHomePageVideoBlock.scss';
import VideoOption from './VideoOption';
import {save} from './api';

type Props = BlockComponentProps<Data>;

interface State {
    videoId: string;
}

interface Data {
    videoOptions: VideoOption[];
    videoId: string;
}

export default class PwsHomePageVideoBlock extends Component<Props, State> {

    public state: State = {
        videoId: this.props.data && this.props.data.videoId,
    };

    public handleVideoSave = async (videoId: string) => {
        await save(videoId);
        this.setState({ videoId });
    }

    public render() {
        const data = this.props.data;
        if (!data || !data.videoOptions || data.videoOptions.length === 0) {
            return <div style={{
                color: '#ccc',
                height: '12em',
                lineHeight: '12em',
                textAlign: 'center',
            }}>
                {t('No video options have been provided by the administrator.')}
            </div>;
        }
        const {videoOptions} = data;
        const videoId = this.state.videoId;
        const {
            previewVideoMdUp: videoMd,
            previewVideoXsDown: videoXs,
            mainVideo: video,
        } = videoOptions.find((o) => `${o.mainVideo.id}` === `${videoId}`) ||
            videoOptions[0];
        const downloadUrl =
            `/vimeo/video/${video.id}/download?width=${video.width}`;
        return <div className="pws-home-page-video-block">
            <a id="pws-home-page-video"/>
            <Editable field={ButtonListSelectField}
                    isEditing={isEditing()}
                    fieldProps={{
                        options: videoOptions.map((o) => ({
                            label: <div className="col-xs-12 col-sm-9">
                                <FixedAspectRatioPlayer video={o.mainVideo} />
                            </div>,
                            value: o.mainVideo.id,
                        })),
                    }}
                    head={<h1 className="modal-title">
                        {t('Choose your Video')}
                    </h1>}
                    onSubmit={this.handleVideoSave}
                    submitOnChange={true}
                    value={videoId}>
                <PreviewAndPopupPlayerContainer
                    previewVideoXsId={videoXs.id}
                    previewVideoXsAspectRatio={`${videoXs.width}:${videoXs.height}`}
                    previewVideoId={videoMd.id}
                    previewVideoAspectRatio={`${videoMd.width}:${videoMd.height}`}
                    mainVideoId={video.id}
                    mainVideoAspectRatio={`${video.width}:${video.height}`}
                    mainVideoDownloadUrl={downloadUrl}
                />
            </Editable>
        </div>;
    }
}
